module.exports = __webpack_public_path__ + "img/full7-min.96f3957b.png";